import React, { useEffect, useMemo }  from 'react';
import { Avatar } from 'antd';
import { RiseOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { InfoWraper, UserDropDwon } from './style';
import { Popover } from '../../ui/popup/popup';
import { logOut } from '../../../redux/authentication/actionCreator';
import FullScreen from './FullScreen';
import Language from './Language';
import ThemeStyle from './ThemeStyle';
import { getASMSalesDashboard } from '../../../redux/ranking/actionCreator';

function AuthInfo() {

    const dispatch = useDispatch();
    const history = useNavigate();
    
    const SignOut = e => {
        e.preventDefault();
        dispatch(logOut());
        setTimeout(() => {
            history('/login', { replace: true });
        }, 100);
    };

    const userDetails = useSelector((state) => state.auth.loginData);
    const rankingData = useSelector((state) => state.asmSalesDashboardData?.data);
    const storeRankingDetails = useMemo(
        () => (
            Array.isArray(rankingData?.store_ranking_details)
                ? rankingData.store_ranking_details
                : []
        ),
        [rankingData],
    );
    const averageMtd = useMemo(() => {
        if (!storeRankingDetails.length) {
            return null;
        }

        const totalMtd = storeRankingDetails.reduce((total, store) => {
            const value = Number.parseFloat(store?.mtd ?? 0)
            return total + value;
        }, 0);

        return Number((totalMtd / storeRankingDetails.length).toFixed(2));
    }, [storeRankingDetails]);

    useEffect(() => {
        if(!userDetails.name){
            dispatch(logOut());
        }
        // eslint-disable-next-line
    },[userDetails])

    useEffect(() => {
        if (userDetails?.loginType?.toLowerCase().includes("sales")) {
            dispatch(getASMSalesDashboard());
        }
    }, [dispatch, userDetails?.loginType]);


    const userContent = (
        <UserDropDwon>
            <div className="user-dropdwon">
                {/* <figure className="user-dropdwon__info">
                    <img src={require(`../../../static/img/logo-icon.png`)} alt="User" width={50} />
                    <figcaption>
                        <Heading as="h5">{userDetails?.name ? userDetails.name.toUpperCase():''}</Heading>
                    </figcaption>
                </figure> */}
                <ul className="user-dropdwon__links">
                    <li>
                        <Link to="/profile/change-password">
                            <FeatherIcon icon="lock" /> Change Password  
                        </Link>
                    </li>
                </ul>
                <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
                    <FeatherIcon icon="log-out" /> Sign Out
                </Link>
            </div>
        </UserDropDwon>
    );

    return (
        <InfoWraper>
            <Link to={"/asm/ranking/dashboard"} className="average-mtd" title="Average MTD conversion across stores">
                <div className="average-mtd__icon-container">
                    <RiseOutlined />
                </div>
                <div className="average-mtd__info">
                    <span className="average-mtd__label">Avg MTD</span>
                    <strong>{averageMtd === null ? '--' : `${averageMtd}%`}</strong>
                </div>
            </Link>
            <Language />
            <FullScreen />
            {/* <ThemeStyle /> */}
            <div className="nav-author">
                <Popover placement="bottomRight" content={userContent} action="click">
                    <Link to="#" style={{ }}>
                        <span className='user-first__name'>{userDetails?.name ? userDetails.name.toUpperCase().split(" ")[0]:''}</span>
                        <Avatar src={require(`../../../static/img/logo-icon.png`)} alt="admin user" /> 
                    </Link>
                </Popover>
            </div>
        </InfoWraper>
    );
}

export default AuthInfo;
